var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"employee-layout"},[_c('router-view',{key:_vm.$route.path}),_c('PricingRequestsPopups',{attrs:{"dependantsList":_vm.dependantsList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }